export const TASK_EFFORT_EVENTS = {
  TASK_VIEWED: 'task_viewed',
  TASK_STATUS_UPDATED: 'task_status_updated',
} as const;

export const TASK_EFFORT_PROPERTIES = {
  TASK_ID: 'task_id',
  TASK_TYPE: 'task_type',
  TASK_CANONICAL_TYPE: 'task_canonical_type',
  TASK_GROUP: 'task_group',
  TASK_CANONICAL_GROUP: 'task_canonical_group',
  MATTER_ID: 'matter_id',
  ASSIGNEE_ID: 'assignee_id',
  IS_ASSIGNED_TO_VIEWER: 'is_assigned_to_viewer',
  CURRENT_STATUS: 'current_status',
  PREVIOUS_STATUS: 'previous_status',
  NEW_STATUS: 'new_status',
  TIME_TO_UPDATE_SECONDS: 'time_to_update_seconds',
  SESSION_ID: 'session_id',
} as const;
